import { COLORS } from "../../assets/utils/enums/colors";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import { BodyDiv, statusBtn } from "../../components/components-style";
import AppLayout from "../../components/layout/app/layout";
import { Button } from "../../components/ui/button";
import Headline from "../../components/ui/headline";
import taskIcon from "../../assets/images/icons/dark/tasks-icon.svg";
import trueStatusIcon from "../../assets/images/icons/done-status-icon.svg";
import falseStatusIcon from "../../assets/images/icons/not-done-status-icon.svg";
import {
  BoldTextBody,
  LittleHeadline,
  LittleSubHeadline,
  LittleText,
  NotificationText,
} from "../../components/typography";
import {
  CommentType,
  NameIdType,
  prioritiesObj,
  PriorityEnum,
} from "../../assets/utils/enums/project";
import { ItemMainBlock } from "../project/details";
import { LinkText } from "../../components/ui/error-text";
import { ButtonSpan } from "../project/details";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from "../../assets/utils/date-formatter";
import { useEffect, useState } from "react";
import getData, { FetchError } from "../../api/project-request";
import { API_URL_COMMENT, API_URL_TASK } from "../../constants";
import toast from "react-hot-toast";
import CustomToast from "../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import styled, { css } from "styled-components";
import { authFetch } from "../../api/authFetch";
import { ModalWindowType } from "../../components/ui/modal-window";
import { ActionsEnum } from "../../assets/utils/enums/settings";
import CommentAdd from "../../components/ui/comment/comment-add";
import CommentListDetails from "../../components/ui/comment/comment-details";
import ErrorPage from "../../components/layout/app/error-page";
import { ErrorVariantEnum } from "../../assets/utils/enums/error-page";
import handleErrorData from "../../api/error-handler";
import { defaultPermissions, mapPermissions } from "../../assets/utils/hooks/usePermissions";

export default function DetailsTaskPage() {
  const { id } = useParams();
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [deadline, setDeadline] = useState<string>("");
  const [createdAt, setCreatedAt] = useState<string>("");
  const [status, setStatus] = useState<boolean>(false);
  const [responsible, setResponsible] = useState<{
    email: string;
    fullName: string;
  }>({ email: "", fullName: "" });
  const [project, setProject] = useState<NameIdType>({ id: "", name: "" });
  const [selling, setSelling] = useState<NameIdType>({ id: "", name: "" });
  const [priority, setPriority] = useState<string>(PriorityEnum.LOW);
  const [users, setUsers] = useState<{ email: string; fullName: string }[]>([]);
  const [comments, setComments] = useState<CommentType[]>([]);
  const [isChangedComments, setIsChangedComment] = useState<boolean>(false);

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorStatus, setErrorStatus] = useState<ErrorVariantEnum | null>(null);
  const [permissions, setPermissions] = useState(defaultPermissions);

  const [modalWindowSettings, setModalWindowSettings] =
    useState<ModalWindowType>({
      isOpen: false,
      onConfirm: () => { },
      onCancel: () => { },
    });

  const getComments = async () => {
    setIsLoading(true);
    try {
      const data = await getData(
        `${API_URL_COMMENT}/get-comments-by-task?taskId=${id}`
      );
      if (Array.isArray(data)) {
        setComments(data);
      } else {
        setComments([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setComments([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    }
  };
  const loadData = async () => {
    try {
      const data = await getData(`${API_URL_TASK}/get-details?id=${id}`);
      if (!data || Object.keys(data).length === 0) {
        setErrorStatus(ErrorVariantEnum.FORBIDDEN);
        return false;
      }

      setName(data.name);
      setDescription(data.description || "—");
      setDeadline(formatDate(data.deadline) || "—");
      setCreatedAt(formatDate(data.createdAt) || "—");
      setResponsible({
        email: data.responsibleEmail,
        fullName: data.responsibleFullName || "",
      });
      setProject({ id: data.projectId, name: data.project || "—" });
      setSelling({ id: data.sellingId, name: data.selling || "—" });
      setPriority(data.priority || PriorityEnum.LOW);
      setStatus(data.status);
      setUsers(
        data.users?.map((m: { email: string; fullName: string }) => ({
          email: m.email || "",
          fullName: m.fullName || "",
        })) || []
      );

      setPermissions(mapPermissions({
        edit: data.isEdit,
        delete: data.isDelete
      }));

      return true;

    } catch (e) {
      const error = e as FetchError;

      handleErrorData(error, setErrorStatus);
      return false;
    }
  };

  useEffect(() => {
    const init = async () => {
      setIsLoading(true);

      const hasAccess = await loadData();

      if (!hasAccess) {
        setIsLoading(false);
        return;
      }

      getComments();
      setIsLoading(false);
    }

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      getComments();
      setIsChangedComment(false);
      setIsLoading(false);
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isChangedComments]);

  async function deleteFunc() {
    const response = await authFetch(`${API_URL_TASK}/${id}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (response.ok) {
      toast((t) => (
        <CustomToast
          t={t}
          type={ToastTypeEnum.INFO}
          text={"Видалення успішне."}
        />
      ));
    }

    setModalWindowSettings((prev) => ({ ...prev, isOpen: false }));
    navigate("/tasks/main");
  }

  if (!isLoading && errorStatus) {
    return (
      <ErrorPage
        variant={errorStatus}
        onAction={() => navigate(-1)}
        additionalBtn="Дo Завдань"
        onActionAddBtn={() => navigate("/tasks/main")}
      />
    );
  }

  return (
    <AppLayout
      className="d-flex flex-column align-items-center gap-2"
      blockType="details-project"
      loaderState={isLoading}
      modalWindow={modalWindowSettings}
    >
      <Headline
        headline={HeadlineTypeEnum.TASKS}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Повернутися до Завдань"
        btn_link="/tasks/main"
        isEdit={false}
      />
      <div className="w-100 d-flex gap-3">
        <BodyDiv
          data-class="detail-main-block"
          className="justify-content-between w-75"
        >
          <div className="d-flex flex-column w-100 gap-3">
            <div className="d-flex align-items-start justify-content-between">
              <span className="d-flex align-items-center gap-3">
                <Button
                  bgcolor={COLORS.main2}
                  txtcolor={COLORS.white}
                  brcolor={"transparent"}
                  width="auto"
                  className="center-btn"
                  brradius="12px"
                  type="large"
                  onClick={() => { }}
                >
                  <img
                    src={taskIcon}
                    className="object-fit-none"
                    alt="task-icon"
                  />
                </Button>
                <span>
                  <LittleHeadline>{name}</LittleHeadline>
                  <span className="d-flex align-items-center gap-2">
                    <NotificationText>Створено:</NotificationText>
                    <BoldTextBody>{createdAt}</BoldTextBody>
                  </span>
                </span>
              </span>
              <StatusSpan
                $bgColor={
                  status ? COLORS["light-green"] : COLORS["light-warning"]
                }
                $txtColor={status ? COLORS.main1 : COLORS.warning}
                $direction={status ? "row-reverse" : "row"}
              >
                <img
                  src={status ? trueStatusIcon : falseStatusIcon}
                  alt="status-icon"
                />
                <LittleText>{status ? "Завершено" : "Не виконано"}</LittleText>
              </StatusSpan>
            </div>
            <span className="w-100 d-flex gap-3">
              <ItemMainBlock className="w-50">
                <NotificationText>Дедлайн</NotificationText>
                <Button
                  bgcolor={COLORS["light-gray"]}
                  txtcolor={COLORS["bg-text-color"]}
                  brcolor={COLORS["gray"]}
                  width="100%"
                  className="center-btn"
                  brradius="24px"
                  type="large"
                  onClick={() => { }}
                >
                  <LittleSubHeadline>{deadline}</LittleSubHeadline>
                </Button>
              </ItemMainBlock>
              <ItemMainBlock className="w-50">
                <NotificationText>Пріорітет</NotificationText>
                <Button
                  bgcolor={prioritiesObj[priority as PriorityEnum].bgColor}
                  txtcolor={prioritiesObj[priority as PriorityEnum].txColor}
                  brcolor={prioritiesObj[priority as PriorityEnum].txColor}
                  width="100%"
                  className="center-btn"
                  brradius="24px"
                  type="large"
                  onClick={() => { }}
                >
                  <LittleText>{priority}</LittleText>
                </Button>
              </ItemMainBlock>
            </span>
            <ItemMainBlock className="max-w-100">
              <NotificationText>Опис</NotificationText>
              <LittleSubHeadline>{description}</LittleSubHeadline>
            </ItemMainBlock>
            <span className="w-100 d-flex gap-5">
              <ItemMainBlock className="">
                <NotificationText>Проєкт</NotificationText>
                {project.name === "—" ? (
                  <LittleSubHeadline>{project.name}</LittleSubHeadline>
                ) : (
                  <a href={`/projects/details/${project.id}`}>
                    <LittleSubHeadline>{project.name}</LittleSubHeadline>
                  </a>
                )}
              </ItemMainBlock>
              <ItemMainBlock className="max-w-100">
                <NotificationText>Продажі</NotificationText>
                {selling.name === "—" ? (
                  <LittleSubHeadline>{selling.name}</LittleSubHeadline>
                ) : (
                  <a href={`/selling/details/${selling.id}`}>
                    <LittleSubHeadline>{selling.name}</LittleSubHeadline>
                  </a>
                )}
              </ItemMainBlock>
            </span>
          </div>

          <ButtonSpan>
            <Button
              bgcolor={COLORS.secondary1}
              txtcolor={COLORS["light-gray"]}
              brcolor={"transparent"}
              width="100%"
              className="center-btn"
              brradius="12px"
              type="small"
              noactive={!permissions.edit}
              onClick={() => {
                if (permissions.edit)
                  navigate(`/tasks/update/${id}`);
                else
                  toast((t) => (
                    <CustomToast
                      t={t}
                      type={ToastTypeEnum.INFO}
                      text={"У вас немає доступу на редагування."}
                    />
                  ))
              }}
            >
              <LittleText>Редагувати дані</LittleText>
            </Button>
            <Button
              bgcolor={COLORS.warning}
              txtcolor={COLORS["light-gray"]}
              brcolor={"transparent"}
              width="100%"
              className="center-btn"
              brradius="12px"
              noactive={!permissions.delete}
              type="small"
              onClick={() => {
                if (permissions.delete)
                  setModalWindowSettings({
                    isOpen: true,
                    onConfirm: deleteFunc,
                    onCancel: () =>
                      setModalWindowSettings((prev) => ({
                        ...prev,
                        isOpen: false,
                      })),
                    action: ActionsEnum.DELETE,
                  });
                else
                  toast((t) => (
                    <CustomToast
                      t={t}
                      type={ToastTypeEnum.INFO}
                      text={"У вас немає доступу на видалення."}
                    />
                  ))
              }}
            >
              <LittleText>Видалити завдання</LittleText>
            </Button>
          </ButtonSpan>
        </BodyDiv>
        <div data-class="detail-add-block" className="w-35">
          <BodyDiv className="h-100 gap-4">
            <ItemMainBlock className="w-100 max-w-100">
              <NotificationText className="pb-1">
                Контакт, що створив завдання
              </NotificationText>
              <LinkText
                mainText={responsible.fullName}
                addText={responsible.email}
              />
            </ItemMainBlock>{" "}
            {users.length !== 0 ? (
              <span>
                <NotificationText>Виконавці завдання</NotificationText>
                <div className="w-100 d-flex flex-wrap gap-3 pt-1">
                  {users.map((item, index) => (
                    <LinkText
                      key={index}
                      mainText={item.fullName}
                      addText={item.email}
                    />
                  ))}
                </div>
              </span>
            ) : (
              <LittleSubHeadline>Інші виконавці відсутні</LittleSubHeadline>
            )}
          </BodyDiv>
        </div>
      </div>
      <CommentAdd type="task" objectId={Number.parseInt(id!)} setIsLoading={setIsLoading} setIsChangedComment={setIsChangedComment} />
      <CommentListDetails comments={comments} setIsChangedComment={setIsChangedComment} setModalWindowSettings={setModalWindowSettings} setIsLoading={setIsLoading} />
    </AppLayout>
  );
}

const StatusSpan = styled.span<{
  $bgColor: string;
  $txtColor: string;
  $direction: string;
}>`
  p {
    white-space: nowrap;
  }
  ${({ $bgColor, $txtColor, $direction }) =>
    css`
      ${statusBtn($bgColor, $txtColor, $direction)};
      gap: 16px;
      padding-${$direction === "row" ? "right" : "left"}: 12px;
      align-items: center;
    `}
`;
